import { useState, useEffect } from "react";
import { C, S, BASE } from '../constants';

export default function CostInput({ productId, cost, delivery, extra, onSave }) {
  const [c, setC] = useState(cost || "");
  const [ex, setEx] = useState(extra || "");
  useEffect(() => { setC(cost || ""); }, [cost]);
  useEffect(() => { setEx(extra || ""); }, [extra]);
  const [st, setSt] = useState("idle"); // idle | saving | saved

  const cNum = parseFloat(c) || 0;
  const exNum = parseFloat(ex) || 0;
  const total = cNum + exNum;

  const save = async () => {
    setSt("saving");
    const token = localStorage.getItem("crm_token");
    await fetch(`${BASE}/api/products/cost`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      body: JSON.stringify({ rozetka_id: productId, cost_price: cNum, delivery_cost: delivery, extra_cost: exNum }),
    });
    setSt("saved");
    onSave(cNum, delivery, exNum);
    setTimeout(() => setSt("idle"), 2000);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <div style={{ display: "flex", gap: 3, alignItems: "center" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <input type="number" value={c} onChange={e => setC(e.target.value)} placeholder="Закупка"
            title="Закупівельна собівартість товару"
            style={{ ...S.input, width: 72, padding: "3px 6px", fontSize: 12 }} />
          <input type="number" value={ex} onChange={e => setEx(e.target.value)} placeholder="Доп. витрати"
            title="Додаткові витрати: упаковка, матеріали тощо"
            style={{ ...S.input, width: 72, padding: "3px 6px", fontSize: 11, opacity: 0.85 }} />
        </div>
        <button onClick={save} title="Зберегти" style={{
          padding: "3px 8px", borderRadius: 6, fontSize: 11, cursor: "pointer", border: "none",
          background: st === "saved" ? C.green : C.blue, color: "#fff", alignSelf: "center",
        }}>{st === "saving" ? "..." : st === "saved" ? "✓" : "OK"}</button>
      </div>
      {exNum > 0 && (
        <div style={{ fontSize: 10, color: C.text3 }}>
          = {total} ₴ разом
        </div>
      )}
      <div style={{ fontSize: 10, color: C.text4 }}>
        📦 {delivery} ₴ авто
      </div>
    </div>
  );
}
